import React from "react";

const Footer = ({ state }) => {
  return (
    <footer className="bg-[var(--MColor)] rounded-t-3xl text-white">
      <div className="container p-8 flex flex-wrap gap-10">
        <div className="about w-1/2 grow">
          <h3 className="text-xl font-bold mb-4">
            {state.langTo === "EN" ? "حول المنصة" : "About"}
          </h3>
          <p>
            {state.langTo === "EN"
              ? 'تم بناء هذه المنصة كمشروع تخرج لنا نحن الطلبة الثلاث (محمد فروانة,اسماعيل عياد,ابراهيم محيسن) تحت اشراف الدكتور الفاضل : "معتز سعد" من كلية تكنولوجيا المعلومات قسم الوسائط المتعددة وتطوير الويب في الجامعة الاسلامية بغزة'
              : "This platform was built as a graduation project for us, the three students (Muhammad Farwana, Ismail Ayad, Ibrahim Muhaisen) under the supervision of the honorable Dr. Moataz Saad from the Faculty of Information Technology, Department of Multimedia and Web Development at the Islamic University of Gaza"}
          </p>
        </div>
        <div className="links w-[min(200px,100%)]">
          <h3 className="text-xl font-bold mb-4">
            {state.langTo === "EN" ? "رابط المصادر" : "Sources link"}
          </h3>
          <a
            href="https://alquran.cloud/api"
            target="_Blank"
            className=" underline"
          >
            alquran.cloud - api
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
